module.exports = __webpack_public_path__ + "img/terrain-textures.ef60d3b8.png";